import { useDispatch } from 'react-redux';
import { useEffectOnce } from 'react-use';

import { getCountries } from '@app/redux/localization/actions';
import { getAllCurrencies } from '@app/redux/currency/actions';

/**
 * Hydrate redux w/ currency and countries from the client side.
 * Note: this should be replaced with react query at some point in the future
 *
 * - @see https://stockx-services.atlassian.net/browse/PWEB-675
 * - @see https://stockx-services.atlassian.net/browse/PWEB-673
 *
 */
const useHydrateReduxData = () => {
  const dispatch = useDispatch();

  useEffectOnce(() => {
    dispatch(getAllCurrencies());
    dispatch(getCountries());
  });
};

export default useHydrateReduxData;
